import { useMutation } from '@apollo/client';

import type { CreateSearchAlertForLoMutation } from '@xing-com/crate-jobs-graphql';
import { CreateSearchAlertForLoDocument } from '@xing-com/crate-jobs-graphql';

import type { SearchAlertHookParams, UseCreateSearchAlertLO } from './types';
import { useShowSearchAlertErrorBanner } from './use-show-search-alert-error-banner';

const createOptimisticUpdate = (): CreateSearchAlertForLoMutation => ({
  __typename: 'Mutation',
  createSearchAlertForLO: {
    __typename: 'SearchAlertForLOCreationSuccess',
  },
});

export const useCreateSearchAlertLO = (
  params?: SearchAlertHookParams
): UseCreateSearchAlertLO => {
  const onCreateError = useShowSearchAlertErrorBanner(
    'CREATE',
    params?.nwtPage
  );

  const DEFAULT_PARAMS = {
    disableOptimisticUpdate: false,
    onError: onCreateError,
  };
  const { disableOptimisticUpdate, onError } = {
    ...DEFAULT_PARAMS,
    ...(params ?? {}),
  };
  const [createSearchAlertLO] = useMutation(CreateSearchAlertForLoDocument);

  return ({ variables, onCompleted }) => {
    if (variables) {
      const { email, query } = variables;
      createSearchAlertLO({
        variables: { email, query },
        optimisticResponse: disableOptimisticUpdate
          ? undefined
          : createOptimisticUpdate(),
        onCompleted: (response) => {
          if (
            response.createSearchAlertForLO?.__typename ===
            'SearchAlertForLOCreationErrorResponse'
          ) {
            onError();
          }

          onCompleted?.(response);
        },
        onError: () => onError(),
      });
    }
  };
};
